import ArticleCategoryListApp from "CMS/ArticleCategoryList/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const articleCategoryRoute: RouteObject = {
  path: "articlecategory",
  children: [{
    path: ":section",
    loader: () => viewModel,
    Component: ArticleCategoryListApp,
  }]
};